import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { SitePage } from '../../Models/SitePage';
import Loader from '../Common/Loader';
import PaginatedTable from '../Common/PaginatedTable';
import { useState } from 'react';
import React from 'react';
import { Link } from 'react-router-dom';
import { HiEye, HiPencilAlt } from 'react-icons/hi';
import { Button, Tooltip } from 'flowbite-react';

export default function SitePagesList({
  data,
  setSelectedSitePage,
  setShowSitePage,
  accessCheck,
}: {
  data: SitePage[];
  setSelectedSitePage: React.Dispatch<React.SetStateAction<number | null>>;
  setShowSitePage: React.Dispatch<React.SetStateAction<boolean>>;
  accessCheck: boolean;
}) {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const editSitePage = (value: number) => {
    setSelectedSitePage(value);
    setShowSitePage(true);
  };

  const columnHelper = createColumnHelper<SitePage>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center'>
          {accessCheck && (
            <Button
              onClick={() => {
                editSitePage(info.getValue());
              }}
              className='buttonMain p-2'
              size={20}
            >
              <HiPencilAlt></HiPencilAlt>
            </Button>
          )}
        </div>
      ),
      footer: (info) => info.column.id,
      size: 20,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.title, {
      id: 'title',
      header: 'Title',
      // cell: (info) => <i>{info.getValue()}</i>,
      footer: (info) => info.column.id,
      //filterFn: 'includesString',
    }),
    columnHelper.accessor((row) => row.header, {
      id: 'header',
      header: 'Header',
      // cell: (info) => <i>{info.getValue()}</i>,
      footer: (info) => info.column.id,
      //filterFn: 'includesString',
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
    },
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });
  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
        />
      </div>
    </>
  );
}
